//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import TransferenciaPosseDefinitivaPasso1 from './TransferenciaPosseDefinitivaPasso1';
import TransferenciaPosseDefinitivaPasso2 from './TransferenciaPosseDefinitivaPasso2';
import TransferenciaPosseDefinitivaPasso3 from './TransferenciaPosseDefinitivaPasso3';
import TransferenciaPosseDefinitivaPasso4 from './TransferenciaPosseDefinitivaPasso4';
import TransferenciaPosseDefinitivaPasso5 from './TransferenciaPosseDefinitivaPasso5';

export default {
  name: 'TransferenciaPosseDefinitivaForm',
  data() {
    return {
      resources: this.$api.transferenciaPosseDefinitiva(this.$resource),

      e1: 0,
      cenario2e3: false,
      objeto: {},
    };
  },
  components: {
    TransferenciaPosseDefinitivaPasso1,
    TransferenciaPosseDefinitivaPasso2,
    TransferenciaPosseDefinitivaPasso3,
    TransferenciaPosseDefinitivaPasso4,
    TransferenciaPosseDefinitivaPasso5,
  },
  computed: {
    ...mapGetters('roles', [
      'getAllRoles',
    ]),
    canAccessPage() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter(el => el === 'TRANS_POSSE_FUN').length;
    },
  },
  methods: {
    accessForbidden() {
      if (!this.canAccessPage) {
        this.$router.push({ name: 'inicio' });
        this.$toast.create('Acesso negado', 'snack', 3E3);
      }
    },
    cancelar() {
      this.$router.push({ name: 'transferencia-posse' });
    },
    continuar(proximoPasso, objeto) {
      this.objeto = objeto;
      if (proximoPasso === 2) {
        if (objeto.cenario === 2 || objeto.cenario === 3) {
          this.cenario2e3 = true;
          this.$refs.passo2.buscarCarteiras(this.objeto.funcionarioDe, this.objeto.funcionarioPara);
          this.$refs.passo3.buscarResponsaveis(this.objeto.funcionarioDe,
            this.objeto.funcionarioPara);
        } else {
          proximoPasso = 4;
        }
      }
      if (proximoPasso === 4) {
        this.$refs.passo4.buscarOrcamentos(this.objeto.funcionarioDe);
      }
      this.e1 = proximoPasso;
    },
    voltar(passo) {
      if (!this.cenario2e3 && passo === 3) {
        passo = 1;
      }
      this.e1 = passo;
    },
    concluir(objeto) {
      objeto.idFuncionarioDe = objeto.funcionarioDe.id;
      objeto.idFuncionarioPara = objeto.funcionarioPara.id;
      // objeto.idsClientesCarteiras = objeto.carteiras.map(el => el.idCliente);
      // objeto.idsCarteiras = objeto.carteiras.map(el => el.idCarteira);
      objeto.idsClientes = objeto.clientes.map(el => el.idCliente);
      objeto.idsLinhasOrcamento = objeto.orcamentos.map(el => el.idLinha);
      objeto.idsTime = objeto.usuarios.map(el => el.id);
      this.resources.transferir(objeto).then(() => {
        this.$toast.create(this.$t('message.adicionado_confira_tabela'), 'snack', '3E3');
        this.$router.push({ name: 'transferencia-posse' });
      }, (err) => {
        this.$toast.create(err.erros[0], 'snack', 5E3);
        // this.$error(this, err);
      });
    },
  },
  beforeMount() {
    if (!this.canAccessPage) {
      window.setTimeout(() => {
        this.accessForbidden();
      }, 1E3);
    }
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/transferencia-posse/definitiva/TransferenciaPosseDefinitivaForm.vue?vue&type=script&lang=js&